import { render } from "./sales-receipt-cash.vue?vue&type=template&id=4a5d632c&scoped=true"
import script from "./sales-receipt-cash.vue?vue&type=script&lang=js"
export * from "./sales-receipt-cash.vue?vue&type=script&lang=js"

import "./sales-receipt-cash.vue?vue&type=style&index=0&id=4a5d632c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5d632c"]])

export default __exports__